import * as AWS from "aws-sdk";
import awsConfig from "./awsConfig";
import SecretsManagerService from './jwt/_services/SecretsManagerService';
const secretsObject = {
  bucket_name_stag: "",
  access_key_id: "",
  secret_access_key: "",
  bucket_name_prod: ""
};
export default () => {

 SecretsManagerService.getSecretValues()
  .then(data => {
    secretsObject.access_key_id = data.data.access_key_id;
    secretsObject.secret_access_key = data.data.secret_access_key;
    secretsObject.bucket_name_prod = "";
    secretsObject.bucket_name_stag = "";
    SecretsManagerService.getDecryptSecretValues(secretsObject).then(Response => {
      AWS.config.update({
        region: awsConfig.region,
        credentials: new AWS.Credentials({
          accessKeyId: Response.data.access_key_id,
          secretAccessKey: Response.data.secret_access_key
        })
      });
  }).catch(
    error => {
      console.error('Error:', error.message);
    }
    );
  })
  .catch(error => {
    console.error('Error:', error.message);
  });
  //alert(response);
  //console.error(AWS);
  // AWS.config.update({
  //   region: awsConfig.region,
  //   credentials: new AWS.Credentials({
  //     accessKeyId: awsConfig.accessKeyId,
  //     secretAccessKey: awsConfig.secretAccessKey
  //   })
  // });
};
